export const es_breadcrumbing = {
    activities_title: 'Nuova Attività',
    activitie_title:'Attività',
    auction_title:'Aste',
    dashboard_title:'Cruscotto',
    help_title:'Hai bisogno di aiuto?',
    map_title:'DETTAGLIO IMMOBILE',
    news_title:'ABTG News',
    myteam_title:' Mi equipo',
    valutation_title:'Valutazioni',
    operation_title: 'Operazioni',
};